import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RunTaskFilterComponent } from "./run-task-filter.component";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [RunTaskFilterComponent],
  exports     : [RunTaskFilterComponent]
})
export class RunTaskFilterComponentModule { }
